import { setLocale } from 'yup';

import { i18n } from '@/assets/translations';

const { t } = i18n.global;

// Configuration of custom yup error messages (form validations)
setLocale({
  mixed: {
    required: t('form.validation.required')
  },
  number: {
    integer: t('form.validation.integer'),
    positive: t('form.validation.positive')
  },
  string: {
    email: t('form.validation.email')
  }
});
